import { Component, EventEmitter, Injectable, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MzBaseModal, MzModalComponent } from 'ngx-materialize';
import { ToastrService } from 'ngx-toastr';
import { actualizarConfiguracionesRequest } from 'src/app/_models/actualizarConfiguracionesRequest.model';
import { CatalogoModel } from 'src/app/_models/bin-catalogos.model';
import { configuracionEsquema } from 'src/app/_models/formularios/configuracionEsquemas.model';
import { REST_SERVICES } from 'src/app/_services/settings';
import { ZeroService } from 'src/app/_services/zero/zero.service';

@Component({
  selector: 'app-modaledit-config-esqu',
  templateUrl: './modaledit-config-esqu.component.html',
  
})

@Injectable()
export class ModaleditConfigEsquComponent extends MzBaseModal {

  public catalogoPlantillas: Array<CatalogoModel>;
  public catalogoInstituciones: Array<CatalogoModel>;
  public catalogoTipoBin: Array<CatalogoModel>;
  public catalogoEsquemas: Array<CatalogoModel>;
  @ViewChild('cancelaEditConfig') cancelaEditConfig: MzModalComponent;
  @ViewChild('ErrorEditConfig') ErrorEditConfig: MzModalComponent;
  public configEditEsq: configuracionEsquema;
  public configEditEsqAnt:configuracionEsquema;
  public actualizarConfiguraciones: actualizarConfiguracionesRequest;

  public modalOptions: Materialize.ModalOptions = {
    dismissible: false,
    opacity: .5,
    inDuration: 300,
    outDuration: 200,
    startingTop: '100%',
    endingTop: '10%',
  };
  @Input() public configEditIn: configuracionEsquema;

  // Emitter para envío de parámetros
  @Output() updateConfig: EventEmitter<actualizarConfiguracionesRequest>;
  constructor(private zeroService: ZeroService,
    private toast: ToastrService,) {
    super();
    this.configEditEsq = new configuracionEsquema();
    this.configEditEsqAnt = new configuracionEsquema();
    this.updateConfig = new EventEmitter();
    this.actualizarConfiguraciones = new actualizarConfiguracionesRequest();
  }

  ngOnInit() {
    this.configEditEsq = Object.assign({},this.configEditIn);
    this.configEditEsqAnt = Object.assign({},this.configEditIn);
    this.buscarCatalogosEsquema();
    this.buscarCatalogosInstitucion();
    this.buscarCatalogosPlantilla();
    this.buscarCatalogosTipoBin();
  }
  buscarCatalogosTipoBin() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CATALOGO_TIPO_BIN,
      method: "GET",
      swhowInfo: true,
      ok: (response) => {
        scope.catalogoTipoBin = response.response;
      }
    });
  }
  buscarCatalogosPlantilla() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CATALOGO_PLANTILLAS,
      method: "GET",
      swhowInfo: true,
      ok: (response) => {
        scope.catalogoPlantillas = response.response;
      }
    });
  }
  buscarCatalogosEsquema() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CATALOGO_ESQUEMAS,
      method: "GET",
      swhowInfo: true,
      ok: (response) => {
        scope.catalogoEsquemas = response.response;
      }
    });
  }
  buscarCatalogosInstitucion() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CATALOGO_INSTITUCIONES.replace("%id", "5"),
      method: "GET",
      swhowInfo: true,
      ok: (response) => {
        scope.catalogoInstituciones = response.response;
      }
    });
  }

  cancelarEditConfig() {
    this.modalComponent.closeModal();
    this.cancelaEditConfig.closeModal();
  }
  public guardarConfig() {
    if (this.configEditEsq.idEsquema == null || this.configEditEsq.idEsquema == undefined ||
      this.configEditEsq.idTipoBin == null || this.configEditEsq.idTipoBin == undefined ||
      this.configEditEsq.idInstitucion == null || this.configEditEsq.idInstitucion == undefined ||
      this.configEditEsq.idPlantilla == null || this.configEditEsq.idPlantilla == undefined
    ) {
      this.ErrorEditConfig.openModal();
    } else {
      this.actualizarConfiguraciones.requestAnt = this.configEditEsqAnt;
      this.actualizarConfiguraciones.requestNu = this.configEditEsq;
      this.updateConfig.emit(this.actualizarConfiguraciones);
      this.modalComponent.closeModal();
    }
  }
}
